// extracted by mini-css-extract-plugin
export default {"splitPoint":"split-points_splitPoint__6asQs"};